import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchRelatedBlogs } from "../features/relatedBlogs/RelatedBlogsSlice";
import RelatedBlogItem from "./RelatedBlogItem";

export default function RelatedBlogs ({tags, currentBlogId}) {
    const { blogs, isLoading, isError, errorMessage } = useSelector(state => state.relatedBlogs);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchRelatedBlogs({ tags, id: currentBlogId }));
    }, [dispatch, tags, currentBlogId]);

    let content = null;
    if (isLoading) {
        content = <div className="col-span-12">Blogs Loading...</div>;
    }
    else if (!isLoading && isError) {
        content = <div className="col-span-12">{errorMessage}</div>;
    }
    else if (!isLoading && !isError && blogs?.length === 0) {
        content = <div className="col-span-12">No blogs found!</div>;
    }
    else {
        content = blogs.map(blog => <RelatedBlogItem key={blog.id} blog={blog} />);
    }

    return (
        <aside>
            <h4 className="mb-4 text-xl font-medium" id="lws-relatedPosts">
                Related Posts
            </h4>
            <div className="space-y-4 related-post-container">
                {content}
            </div>
        </aside>
    );
}